/** Display values stored on user profile and in welcome email (English labels). */
export const REFERRAL_SOURCE_OTHER = 'Other'

export const REFERRAL_SOURCES = [
  'Google Search',
  'Google Ads',
  'Reddit',
  'Facebook',
  'Instagram',
  'YouTube',
  'Tiktok',
  'ChatGPT',
  'Email',
  REFERRAL_SOURCE_OTHER,
]
